module.exports = __webpack_public_path__ + "static/media/1POLICY21.d99f67af.jpg";